import { StandardCSSProperties } from '../types.js';
import { MUI_BORDER_RADIUS, MUI_SPACING, twBorderRadius } from './constants.js';
import { fromThemePaletteStyle } from './from-theme-palette-style.js';
import { sizingHelper } from './sizing-helper.js';
import { stringOrNumberDefined } from './string-or-number-defined.js';

export const addons: Record<
  | 'borderRadius'
  | 'backgroundColor'
  | 'borderColor'
  | 'color'
  | 'width'
  | 'height'
  | 'minWidth'
  | 'minHeight'
  | 'maxWidth'
  | 'maxHeight'
  | 'gap'
  | 'rowGap'
  | 'columnGap'
  | 'top'
  | 'right'
  | 'bottom'
  | 'left',
  (value: string | number) => {
    className?: string;
    style?: StandardCSSProperties;
  }
> = {
  borderRadius: (value) =>
    stringOrNumberDefined(value, 'borderRadius', (val) =>
      twBorderRadius[val]
        ? {
            className: twBorderRadius[val],
          }
        : {
            style: {
              borderRadius: `${val * MUI_BORDER_RADIUS}px`,
            },
          },
    ),
  backgroundColor: fromThemePaletteStyle('backgroundColor'),

  borderColor: fromThemePaletteStyle('borderColor'),

  color: fromThemePaletteStyle('color'),
  width: sizingHelper('width'),
  height: sizingHelper('height'),
  minWidth: sizingHelper('minWidth'),
  minHeight: sizingHelper('minHeight'),
  maxWidth: sizingHelper('maxWidth'),
  maxHeight: sizingHelper('maxHeight'),

  gap: (value) =>
    stringOrNumberDefined(value, 'gap', (val) => ({
      style: {
        gap: `${val * MUI_SPACING}px`,
      },
    })),

  rowGap: (value) =>
    stringOrNumberDefined(value, 'rowGap', (val) => ({
      style: {
        rowGap: `${val * MUI_SPACING}px`,
      },
    })),

  columnGap: (value) =>
    stringOrNumberDefined(value, 'columnGap', (val) => ({
      style: {
        columnGap: `${val * MUI_SPACING}px`,
      },
    })),

  top: (value) =>
    stringOrNumberDefined(value, 'top', (val) => ({
      style: {
        top: `${val * MUI_SPACING}px`,
      },
    })),

  right: (value) =>
    stringOrNumberDefined(value, 'right', (val) => ({
      style: {
        right: `${val * MUI_SPACING}px`,
      },
    })),

  bottom: (value) =>
    stringOrNumberDefined(value, 'bottom', (val) => ({
      style: {
        bottom: `${val * MUI_SPACING}px`,
      },
    })),

  left: (value) =>
    stringOrNumberDefined(value, 'left', (val) => ({
      style: {
        left: `${val * MUI_SPACING}px`,
      },
    })),
};

export const addonsKeys = Object.keys(addons) as string[];
